import { SCta } from 'src/rest/types/api/Common'
import { ActionButtonProps } from 'src/components/ActionButton'
import { STheme } from 'src/rest/types/api/Theme'

import { ActionIconBackground } from '../../components/ActionButton/types'

import { getThemeColor } from './ThemeTransformer'

export function ButtonTransformer({
  data,
  theme,
  forceColor,
  iconBackground,
}: {
  data?: SCta
  theme?: STheme
  forceColor?: string
  iconBackground?: ActionIconBackground
}): ActionButtonProps | undefined {
  return data?.url
    ? {
        label: data?.label || '',
        target: data?.target || '_self',
        href: data?.url,
        iconColor: getThemeColor(theme) ?? forceColor ?? undefined,
        iconBackground: iconBackground ?? ActionIconBackground.default,
      }
    : undefined
}
